<template>
  <div class="wrap h-100">
    <!-- 資訊區 -->
    <div class="amount-wrap h-100">
      <div class="unpaid">
        <p>應收</p>
        <p :style="getOrderAmount?.toString().length > 5 ? 'font-size: 3.6rem' : ''">{{ getOrderAmount }}</p>
      </div>
      <div class="paid">
        <div v-if="selectItem" class="cancel" @click="cancel">
          <i class="bi bi-x-circle-fill"></i>
        </div>
        <div v-if="selectItem" class="content">
          <p>{{ actionName + '&ensp;一&ensp;' }}</p>
          <p :class="number ? '' : 'empty'">{{ number || '請輸入數字' }}</p>
        </div>
        <p v-else class="empty">尚無資訊</p>
      </div>
      <cus-button
        text="確定"
        color="green"
        style="margin: 0; padding: 0"
        @click="submit"
        :disabled="!selectItem || !number"
      ></cus-button>
    </div>
    <!-- 按鈕區 -->
    <div class="pay-wrap h-100">
      <cus-button
        v-for="(item, index) in Object.keys(payBtns)"
        :key="index"
        :text="
          item === 'delivery_collection'
            ? payBtns[item].label.length > 6
              ? payBtns[item].label.textBreak(9, 4)
              : payBtns[item].label.textBreak(4, 4)
            : payBtns[item].label.textBreak(3, 4)
        "
        :color="payBtns[item].color"
        :style="`grid-area:${payBtns[item].area}`"
        :disabled="!handleDisable(payBtns[item].checkDisable, payBtns[item])"
        @click="handleClick(payBtns[item].click, payBtns[item])"
      ></cus-button>
      <cus-button
        text="旺卡加值"
        color="white"
        style="grid-area: 5 / 1 / 6 / 2"
        :disabled="!getDayungsPayment?.want_card"
        @click="addWantCard"
      ></cus-button>
      <div class="invoice" style="grid-area: 2 / 6 / 6 / 7">
        <invoice v-model:selectItem="selectItem" v-model:number="number"></invoice>
      </div>
      <div class="keyboard" style="grid-area: 2 / 2 / 6 / 6">
        <keyboard v-model:number="number" :amountValid="amountValid" :numberValid="numberValid"></keyboard>
      </div>
    </div>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, getCurrentInstance, computed, defineAsyncComponent, watch } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { getPayButtons, getPaymentType } from '@/utils/define';
import { getAmount } from '@/utils/amount';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'select-pay',
  components: {
    Keyboard: defineAsyncComponent(() => import('@/components/checkout/right/Keyboard.vue')),
    Invoice: defineAsyncComponent(() => import('@/components/checkout/right/Invoice.vue')),
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
    Alert: defineAsyncComponent(() => import('@/components/dialog/Alert.vue')),
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得清單
    const payBtns = getPayButtons();
    const { getOrderAmount, getPaidList, getPaymentPermission, getPayStatus } = useGetters('checkout', [
      'getOrderAmount',
      'getPaidList',
      'getPaymentPermission',
      'getPayStatus',
    ]);
    const getDayungsPayment = useGetters('member', ['getDayungsPayment']);
    //輸入內容資訊欄
    const selectItem = ref(null);
    const actionName = computed(() => selectItem.value?.label);
    const number = ref(null);
    // 確認送出
    const doCheckTax = useActions('checkout', ['doCheckTax']);
    const SET_PAID_LIST = useMutations('checkout', ['SET_PAID_LIST']);
    const submit = () => {
      switch (selectItem.value.label) {
        case '統編':
          submitTax();
          break;
        default:
          submitPay();
          break;
      }
      async function submitTax() {
        if (number.value.length !== 8) {
          proxy.$message('錯誤提示', '需輸入8碼數字').catch((e) => e);
          return;
        }
        await doCheckTax(number.value);
        cancel();
      }
      function submitPay() {
        if (number.value.length > 8) {
          proxy.$message('錯誤提示', '金額過大').catch((e) => e);
          return;
        }
        const type = computed(() =>
          getPaidList.value?.length > 0 && getPaidList.value[0].type !== 1 ? '差額' : '全額'
        );
        switch (type.value) {
          case '全額':
            //禮券和台積卡可以用現金補差額
            if (
              Number(number.value) < getOrderAmount.value &&
              selectItem.value.type !== 5 &&
              selectItem.value.type !== 41
            ) {
              proxy.$message('錯誤提示', '不可低於未收金額').catch((e) => e);
              return;
            }
            break;
          case '差額':
            if (!Number(number.value)) {
              proxy.$message('錯誤提示', '未輸入金額').catch((e) => e);
              return;
            }
            break;
        }
        SET_PAID_LIST({
          label: selectItem.value.label,
          type: selectItem.value.type,
          payment_type: selectItem.value.payment_type,
          amount: Number(number.value),
        });
        cancel();
      }
    };
    //取消選擇
    const cancel = () => {
      selectItem.value = null;
      number.value = null;
    };
    //----------------------------------------------------------------------
    //執行function
    const handleClick = (event, value) => {
      proxy[event](value);
    };
    const handleDisable = (event, value) => {
      //proxy[event]分別執行 payDisable,dayungsDisable,cardDisable
      return proxy[event](value);
    };
    //*按鈕狀態----------------------------------------------------------------
    //取得付款type陣列&未收金額
    const paidListType = computed(() => getPaidList.value.map((e) => e.type));
    const { computeUnpaid } = getAmount();
    //現金的disable
    const cashDisable = () => {
      if (!getPaymentPermission.value?.cash.is_enable) return false;
      if (getOrderAmount.value === 0) return false;
      if (paidListType.value.length === 0) return true;
      else {
        //以下邏輯複雜，不要輕易改
        const paymentData = getPaymentType(getPaidList.value[0].payment_type);
        if (!paymentData.withCash) return false;
        else if (!cardDisable(payBtns.want_card) && computeUnpaid.value > 0) return true;
        else if (paidListType.value.includes(1)) return true;
        else return false;
      }
    };
    //卡片支付的disable(信用卡/悠遊卡/一卡通)
    const cardPayDisable = () => {
      if (
        !getPaymentPermission.value?.credit_card.is_enable &&
        !getPaymentPermission.value?.easy_card.is_enable &&
        !getPaymentPermission.value?.i_pass.is_enable
      )
        return false;
      if (paidListType.value.length > 0) return false;
      if (getOrderAmount.value <= 0) return false;
      return true;
    };
    //其他支付的disable(禮券/園區員工卡)
    const otherPayDisable = () => {
      if (
        !getPaymentPermission.value?.gift_certificate.is_enable &&
        !getPaymentPermission.value?.park_employee_card.is_enable
      )
        return false;
      if (paidListType.value.length > 0) return false;
      if (getOrderAmount.value <= 0) return false;
      return true;
    };
    //第三方、外送平台 的disable
    const payDisable = (item) => {
      if (!getPaymentPermission.value[item.payment_type].is_enable) return false;
      if (paidListType.value.length > 0) return false;
      if (getOrderAmount.value <= 0) return false;
      return true;
    };
    //大苑子支付的disable
    const dayungsDisable = () => {
      if (
        !getPaymentPermission.value?.want_card.is_enable &&
        !getPaymentPermission.value?.cash_card.is_enable &&
        !getPaymentPermission.value?.want_card_point.is_enable
      )
        return false;
      if (paidListType.value.length > 0) return false;
      if (getOrderAmount.value <= 0) return false;
      return true;
    };
    // 旺卡、現金卡、黃金點數 的disable
    const getMemberInformation = useGetters('member', ['getMemberInformation']);
    const cardDisable = (item) => {
      const paymentData = getPaymentType(item.payment_type);
      if (!getDayungsPayment.value) return false; //沒資料
      if (!getPaymentPermission.value[paymentData.payment_type].is_enable) return false;
      if (computeUnpaid.value === 0) return false; //全額付清
      if (paidListType.value.includes(30) && paymentData.type === 30) return false; //旺卡一次性使用
      if (paymentData.type === 30 && getMemberInformation.value?.want_card_card_link) return true; //旺卡有自動加值功能
      if (!getDayungsPayment.value[paymentData.payment_type]?.balance) return false; //null
      if (getDayungsPayment.value[paymentData.payment_type]?.balance <= 0) return false; //沒餘額
      if (paidListType.value.length > 0 && paymentData.type === 32) return false; //現金卡不能補差額
      if (paidListType.value.includes(31) && paymentData.type === 31) return false; //點數一次性使用
      return true;
    };
    //*點擊----------------------------------------------------------------
    //檢查有沒有大苑子支付
    const SET_DAYUNGS_PAYMENT = useMutations('member', ['SET_DAYUNGS_PAYMENT']);
    const checkChangePayment = () => {
      return new Promise((resolve, reject) => {
        if (getDayungsPayment.value) {
          proxy
            .$confirm({
              content: '使用此付款方式，將無法搭配使用大苑子支付，是否確定切換？',
              confirmText: '確定',
            })
            .then(() => {
              SET_DAYUNGS_PAYMENT(null);
              resolve();
            })
            .catch(() => {
              reject();
            });
        } else {
          resolve();
        }
      });
    };
    //現金支付
    const handleCash = async (item) => {
      //現金如果是作為補差額用的，不需要檢查有沒有大苑子支付
      if (getPaidList.value.length === 0) {
        await checkChangePayment();
        number.value = null;
        selectItem.value = getPaymentType(item.payment_type);
      } else {
        number.value = null;
        selectItem.value = getPaymentType(item.payment_type);
      }
    };
    //卡片支付和其他支付(打開彈窗)
    const cardPayBtns = computed(() => {
      return [
        {
          label: '信用卡',
          value: 'credit_card',
          disable: !getPaymentPermission.value.credit_card.is_enable,
        },
        {
          label: '悠遊卡',
          value: 'easy_card',
          disable: !getPaymentPermission.value.easy_card.is_enable,
        },
        { label: '一卡通', value: 'i_pass', disable: !getPaymentPermission.value.i_pass.is_enable },
      ];
    });
    const otherPayBtns = computed(() => {
      return [
        {
          label: '禮券',
          value: 'gift_certificate',
          disable: !getPaymentPermission.value.gift_certificate.is_enable,
        },
        {
          label: '園區員工卡',
          value: 'park_employee_card',
          disable: !getPaymentPermission.value.park_employee_card.is_enable,
        },
        {
          label: 'PandaGo代收',
          value: 'panda_go',
          disable: !getPaymentPermission.value.panda_go.is_enable,
        },
      ];
    });
    const handleOpenPay = async (item) => {
      const open = () => {
        switch (item.openDialog) {
          case 'card_payment':
            openDialog('chooseMorePay', {}, { dialogTitle: item.label, dialogList: cardPayBtns.value });
            break;
          case 'other_payment':
            openDialog('chooseMorePay', {}, { dialogTitle: item.label, dialogList: otherPayBtns.value });
            break;
        }
      };
      await checkChangePayment();
      open();
    };
    //卡片支付和其他支付(選擇支付方式)
    const handleChoosePay = (val) => {
      const paymentData = getPaymentType(val.value);
      switch (val.value) {
        case 'gift_certificate':
          // case 'park_employee_card':
          selectItem.value = paymentData;
          number.value = null;
          break;
        default:
          SET_PAID_LIST({
            label: paymentData.label,
            type: paymentData.type,
            payment_type: paymentData.payment_type,
            amount: Number(getOrderAmount.value),
          });
          break;
      }
      closeDialog();
    };
    //第三方、外送平台 的支付
    const getSource = useGetters('order', ['getSource']);
    const handlePay = async (item) => {
      await checkChangePayment();
      const paymentData = getPaymentType(item.payment_type, getSource.value);
      SET_PAID_LIST({
        label: paymentData.label,
        type: paymentData.type,
        payment_type: paymentData.payment_type,
        amount: Number(getOrderAmount.value),
      });
    };
    //大苑子支付
    const doQueryCard = useActions('member', ['doQueryCard']);
    const handleDayungs = async () => {
      cancel();
      try {
        openDialog('noticeScan', { scanType: 1 }, { dialogContent: `請感應/掃描<br/>大苑子支付` });
        await doQueryCard();
        closeDialog();
      } catch (error) {
        closeDialog();
      }
    };
    // 旺卡、現金卡 的支付
    const handleDayungsCard = (item) => {
      cancel();
      let amount =
        computeUnpaid.value > getDayungsPayment.value[item.payment_type].balance
          ? getDayungsPayment.value[item.payment_type].balance
          : computeUnpaid.value;
      const paymentData = getPaymentType(item.payment_type);
      SET_PAID_LIST({
        label: paymentData.label,
        type: paymentData.type,
        payment_type: paymentData.payment_type,
        card_no: getDayungsPayment.value[paymentData.payment_type].card_no,
        is_digital_card: getDayungsPayment.value[paymentData.payment_type].is_digital_card,
        amount,
      });
    };
    //如果訂單金額為負值(小於0)且有旺卡資料，自動帶入負值的旺卡支付，代表要把金額退到旺卡裡(自備杯獎勵的金額)
    watch(
      getOrderAmount,
      () => {
        if (getOrderAmount.value < 0 && getDayungsPayment.value) {
          const paymentData = getPaymentType('want_card');
          SET_PAID_LIST({
            label: paymentData.label,
            type: paymentData.type,
            payment_type: paymentData.payment_type,
            card_no: getDayungsPayment.value[paymentData.payment_type].card_no,
            amount: getOrderAmount.value,
            is_digital_card: getDayungsPayment.value[paymentData.payment_type].is_digital_card,
          });
        }
      },
      { immediate: true }
    );
    // 黃金點數支付
    const handlePoint = () => {
      cancel();
      openDialog('useWantCardPoint');
    };
    const handleUsePoint = (val) => {
      const max =
        computeUnpaid.value > getDayungsPayment.value.want_card_point.balance
          ? getDayungsPayment.value.want_card_point.balance
          : computeUnpaid.value;
      if (val > max) {
        proxy.$message('錯誤提示', `點數不可大於${max}`).catch((e) => e);
        return;
      }
      const paymentData = getPaymentType('want_card_point');
      SET_PAID_LIST({
        label: paymentData.label,
        type: paymentData.type,
        payment_type: paymentData.payment_type,
        card_no: getDayungsPayment.value.want_card_point.card_no,
        amount: val,
        is_digital_card: getDayungsPayment.value.want_card_point.is_digital_card,
      });
      closeDialog();
    };
    // 旺卡加值
    const addWantCard = () => {
      cancel();
      openDialog('wantCardAdd', { note: `(以佰元為單位，差額：${computeUnpaid.value})` });
    };
    const doAddCardVale = useActions('member', ['doAddCardVale']);
    const handleWantCardMoney = async (val) => {
      if (val % 100 !== 0) {
        proxy.$message('錯誤提示', '加值金額須以佰元為單位').catch((e) => e);
        return false;
      }
      await doAddCardVale({
        card_no: getDayungsPayment.value.want_card.card_no,
        value: val,
        is_digital_card: getDayungsPayment.value.want_card.is_digital_card,
        member_card_no: getMemberInformation.value?.card_no || '',
      });
      openDialog('completeAddCard');
    };
    // 完成旺卡加值，如果旺卡已使用金額須重算
    const REMOVE_PAID = useMutations('checkout', ['REMOVE_PAID']);
    const handleCompleteAddCard = () => {
      closeDialog();
      const wand_card_index = computed(() => paidListType.value.indexOf(30));
      if (wand_card_index.value > -1 && !getPayStatus.value) {
        //旺卡已在支付列但是旺卡餘額有變動
        const cashIndex = paidListType.value.indexOf(1);
        if (cashIndex > -1) REMOVE_PAID(cashIndex);
        const temUnpaid = computeUnpaid.value + getPaidList.value[wand_card_index.value].amount;
        let amount =
          temUnpaid > getDayungsPayment.value.want_card.balance ? getDayungsPayment.value.want_card.balance : temUnpaid;
        const paymentData = getPaymentType('want_card');
        SET_PAID_LIST({
          label: paymentData.label,
          type: paymentData.type,
          payment_type: paymentData.payment_type,
          card_no: getDayungsPayment.value.want_card.card_no,
          is_digital_card: getDayungsPayment.value[paymentData.payment_type].is_digital_card,
          member_card_no: getMemberInformation.value?.card_no || '',
          amount,
        });
        const message_arr = getPaidList.value.map((el) => {
          return `${el.label} - ${el.amount}元`;
        });
        proxy.$message('付款方式變更', `${message_arr.join('<br/>')}`, { confirmText: '我知道了' }).catch((e) => e);
      }
    };
    //控制數字鍵盤
    const amountValid = computed(() => {
      if (selectItem.value?.type === 1 || selectItem.value?.type === 5 || selectItem.value?.type === 41) return true;
      else return false;
    });
    const numberValid = computed(() => {
      if (
        selectItem.value?.type === 1 ||
        selectItem.value?.type === 5 ||
        selectItem.value?.type === 41 ||
        selectItem.value?.label === '統編'
      )
        return true;
      else return false;
    });
    return {
      dialogTemplate,
      getOrderAmount,
      getDayungsPayment,
      getPaidList,
      payBtns,
      selectItem,
      actionName,
      number,
      submit,
      cancel,
      handleClick,
      handleDisable,
      cashDisable,
      cardPayDisable,
      otherPayDisable,
      payDisable,
      dayungsDisable,
      cardDisable,
      handleCash,
      handleOpenPay,
      handleChoosePay,
      handlePay,
      handleDayungs,
      handleDayungsCard,
      handlePoint,
      handleUsePoint,
      addWantCard,
      handleWantCardMoney,
      handleCompleteAddCard,
      amountValid,
      numberValid,
    };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-template-rows: 17% auto;
  grid-gap: 8px;
}
.amount-wrap {
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-gap: 8px;
  .unpaid {
    background-color: $color-darkBlue;
    border-radius: 4px;
    color: #fff;
    font-size: 2rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    padding: 0 4px;
    @include flex-center-center;
    flex-direction: column;
    p:nth-of-type(2) {
      font-size: 4.2rem;
      line-height: 5rem;
    }
  }
  .paid {
    @include white-bg;
    @include flex-center-center;
    position: relative;
    .content {
      font-size: 3.2rem;
      color: $color-blue;
      @include flex-center-center;
    }
    .empty {
      font-size: 1.8rem;
      color: $color-gray-30;
    }
    .cancel {
      @include base-cancel(4px, 10px);
    }
  }
}
.pay-wrap {
  @include white-bg;
  padding: 4px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1.2fr repeat(4, 1fr);
}
</style>
